// import { getQueueLength } from "../../utils/offlineQueue";
import { useOfflineQueue } from "../../providers/offlineQueueProvider";
import { Button } from "react-bootstrap";
import { faFilePdf, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OfflineProtocolQueue = ({ onEdit }) => {
    const { protocols, retryQueue, isSyncing } = useOfflineQueue();


  if (protocols.length === 0) {
    return;
  }

  function parseType(type) {
    switch (type) {
      case "default":
        return "Domyślny";
      case "inspection":
        return "Protokół";
      default:
        return type;
    }
  }

  return (
    <div className="p-3 border rounded">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="m-0">📤 Protokoły oczekujące na wysłanie</h5>
        <Button
          variant="primary"
          size="sm"
          onClick={retryQueue}
          disabled={isSyncing}
        >
          <FontAwesomeIcon
            icon={faSyncAlt}
            spin={isSyncing}
            className="me-2"
          />
          {isSyncing ? "Synchronizowanie..." : "Synchronizuj"}
        </Button>
      </div>
      <div className="d-grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))" }}>
        {protocols.map(({ id, data }) => (
          <div key={id} className="border p-3 rounded d-flex align-items-center bg-light shadow-sm">
            <FontAwesomeIcon icon={faFilePdf} size="3x" className="me-3 text-danger" />
            <div className="flex-grow-1">
              {data?.building?.building_name && (
                <div><strong>Obiekt:</strong> {data.building.building_name}</div>
              )}
              <div><strong>Typ:</strong> {parseType(data?.type)}</div>
              <div><strong>Data:</strong> {new Date(data?.date || Date.now()).toLocaleDateString()}</div>
            </div>
            {onEdit && (
              <Button
                variant="outline-primary"
                size="sm"
                className="ms-3"
                onClick={() => onEdit(id)}
              >
                Edytuj
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OfflineProtocolQueue;
